(function () {
  if (customElements.get('ce-custom-field-checkbox') !== undefined) {
    return;
  }

  class CustomFieldCheckbox extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        inputHidden: '[data-custom-field-checkbox-input-hidden]',
        inputVisible: '[data-custom-field-checkbox-input-visible]',
        required: '[data-custom-field-checkbox-required]',
      };

      this.elements = null;

      this._handleChange = this._handleChange.bind(this);
    }

    parsedCallback() {
      this.elements = {
        inputHidden: this.querySelector(this.selectors.inputHidden),
        inputVisible: this.querySelector(this.selectors.inputVisible),
        required: this.querySelector(this.selectors.required),
      };

      this.elements.inputVisible.addEventListener('change', this._handleChange);
    }

    disconnectedCallback() {
      this.elements.inputVisible.removeEventListener('change', this._handleChange);
    }

    _handleChange(event) {
      if (event.target.checked) {
        this.elements.required?.classList.add('opacity-0');
        this.elements.inputHidden.value = this.dataset.true;
      } else {
        this.elements.required?.classList.remove('opacity-0');
        this.elements.inputHidden.value = this.dataset.false;
      }
    }
  }

  customElements.define('ce-custom-field-checkbox', CustomFieldCheckbox);
})();
